import React from "react";
import { Box, Typography } from "@mui/material";
import getModalStyles from "./ModalBody.styles";
import CloseButton from '../CloseButton'
type ModalBodyProps = {
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  onClose?: () => void;
  sxBody?: object;
  ref?: any;
};

export default function ModalBody({
  title,
  children,
  footer,
  onClose,
  sxBody,
  ref,
}: ModalBodyProps) {
  const modalStyles = getModalStyles()
  return (
    <Box>
      {title && (
        <Box sx={modalStyles.header}>
          <Typography variant="h5" sx={modalStyles.title}>
            {title}
          </Typography>
          {onClose && (
            <CloseButton onClick={onClose}></CloseButton>
          )}
        </Box>
      )}

      <Box sx={{ ...modalStyles.body, ...sxBody }} ref={ref}>
        {" "}
        {children}
      </Box>

      {footer && <Box sx={modalStyles.footer}>{footer}</Box>}
    </Box>
  );
}
